

















































































































































import { Component, Prop, Vue } from 'vue-property-decorator';
import { TableItem, TableHeaderItem } from '@/utils/types';
import { Getter, namespace } from 'vuex-class';
import ClipLoader from 'vue-spinner/src/ClipLoader.vue';

// const event = namespace('event');

// TODO: Не вызывать функцию редактирования для inline-редактора

@Component({
  components: {
    ClipLoader
  }
})
export default class WidgetTable extends Vue {

  @Prop({ type: Array, default: [] }) protected headers!: TableHeaderItem[];
  @Prop({ type: Array, default: [] }) protected items!: TableItem[];

  @Prop({ type: Boolean, default: false }) protected deleteWithoutConfirm?: boolean;

  @Prop({ type: Boolean, default: false }) protected isAltColor?: boolean;

  @Prop({ type: Boolean, default: false }) protected hideFilter?: boolean;
  @Prop({ type: Boolean, default: false }) protected hideFooter?: boolean;
  @Prop({ type: Boolean, default: false }) protected hideHeader?: boolean;

  @Prop({ type: Number, default: 1000 }) protected width?: Number;

  @Prop({ type: Array, default: () => [] }) protected editColumns?: String[];

  @Prop({ type: Array, default: () => [] }) protected itemStates?: [];

  @Prop({ type: Function, default: null }) protected addItemCB?: () => any;
  @Prop({ type: Function, default: null }) protected deleteItemCB?: (item: TableItem) => any;
  @Prop({ type: Function, default: null }) protected activateItemCB?: (item: TableItem) => any;
  @Prop({ type: Function, default: null }) protected printItemCB?: (item: TableItem) => any;

  @Prop({ type: Boolean, default: false }) protected hidePrintOper?: boolean;
  @Prop({ type: Boolean, default: false }) protected loadState?: boolean;
  @Prop({ type: String, default: '' }) protected loadLabel?: string;

  @Prop({ type: Boolean, default: false }) protected isDefaultOffsetColor?: boolean;

  protected liveFilter: string = '';

  protected stateDeleteDialog: boolean = false;
  private deletingItem: TableItem | null = null;

  // TODO: Исправить валидацию в ячейках таблицы - сделать универсальное решение
  protected rules: any = null;

  // @event.State('mvk') protected eventMvk: any;
  // @event.Getter('defaultColor') protected eventDefaultColor: any;
  // @event.Getter('defaultCode') protected eventDefaultCode: any;
  // protected get eventColor() {
  //   return this.eventMvk && this.eventMvk.color ? this.eventMvk.color : this.eventDefaultColor;
  // }
  // protected get eventCode() {
  //   return this.eventMvk && this.eventMvk.code ? this.eventMvk.code : this.eventDefaultCode;
  // }
  // protected get color() {
  //   return this.isDefaultOffsetColor ? `#${this.eventDefaultColor}!important` : `#${this.eventColor}!important`;
  // }
  protected get color() {
    return '#2c9cdb !important';
  }

  protected tryDelete(item: TableItem) {
    if (this.deleteWithoutConfirm) {
      if (this.deleteItemCB) {
        this.deleteItemCB(item);
      }
    }
    else {
      this.deletingItem = item;
      this.stateDeleteDialog = true;
    }
  }

  protected tryPrint(item: TableItem) {
    if (this.printItemCB) {
      this.printItemCB(item);
    }
  }

  private deleteYes() {
    this.stateDeleteDialog = false;
    if (this.deleteItemCB && this.deletingItem)
      this.deleteItemCB(this.deletingItem);
  }
  private deleteNo() {
    this.stateDeleteDialog = false;
    this.deletingItem = null;
  }

  private activateItem(item: TableItem) {
    if (this.activateItemCB) this.activateItemCB(item);
  }

  protected get tableHeaders() {

    let headers = [];

    if (this.itemStates && this.itemStates.length > 0)
      headers.push({ value: 'states', text: '', align: 'start' });

    headers.push(...this.headers);

    if (this.deleteItemCB)
      headers.push({ value: 'opers', text: '', align: 'end' });

    return headers;

  }

  protected beforeMount() {

    this.rules = {
      numbers: (value: string) => /^[0-9]{1,1}$/.test(value) || this.$t('table.error_edit') as string,
    }

  }

}

